// src/padplanner/StatusPill.jsx
//
// A plan's status as a small pill: op-chip and op-dot at the mockups' height
// (op-chip--status is h-8, too tall for a table row or a card). The color is
// planStatus.js's, so the pill matches the bar, the legend and the map.
//
// An archived plan says Archived, in the draft gray: archive is not a status
// (the plan keeps its own), but it is what a reader needs to know first.
import { STATUS_LABELS } from "./planVocabulary";
import { STATUS_STYLE } from "./planStatus";

export default function StatusPill({ status, archived = false, suffix = null }) {
  const style = archived ? STATUS_STYLE.draft : (STATUS_STYLE[status] ?? STATUS_STYLE.draft);
  const label = archived ? "Archived" : (STATUS_LABELS[status] ?? status);
  return (
    <span className={`op-chip h-5 shrink-0 gap-1.5 rounded-full px-2 py-0 ${style.text}`}
      data-testid="pp-status-pill" data-status={archived ? "archived" : status}>
      <span className="op-dot" aria-hidden="true" />
      <span className="text-fg-primary">{label}{suffix ? ` · ${suffix}` : ""}</span>
    </span>
  );
}
